/* Read Shopify's existing cart; never creates or modifies cart items. */
(() => {
  if (window.ghmHeaderCartReady) return;
  const links = [...document.querySelectorAll('[data-ghm-header-cart]')];
  if (!links.length) return;
  window.ghmHeaderCartReady = true;
  let timer, running = false, queued = false;
  const update = count => {
    if (!Number.isSafeInteger(count) || count < 0) return;
    const description = `View cart, ${count} ${count === 1 ? 'item' : 'items'}`;
    for (const link of links) {
      const changed = link.dataset.cartCount !== String(count);
      link.dataset.cartCount = String(count);
      link.setAttribute('aria-label', description);
      link.querySelector('[data-ghm-cart-count]').textContent = count > 99 ? '99+' : String(count);
      if (changed) link.querySelector('[data-ghm-cart-status]').textContent = `${count} ${count === 1 ? 'item' : 'items'} in your cart.`;
    }
  };
  const refresh = async () => {
    if (running) { queued = true; return; }
    running = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (response.ok) update((await response.json()).item_count);
    } catch (_) {
      // Keep the last known count when a read fails; the cart link still works.
    } finally {
      running = false;
      if (queued) { queued = false; schedule(); }
    }
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 80); };
  document.addEventListener('ghm:cart-added', schedule);
  document.addEventListener('shopify:cart:lines-update', event => {
    if (event.promise) Promise.resolve(event.promise).then(schedule).catch(() => {});
    else schedule();
  });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  schedule();
})();
